import React from 'react'
import { SpecialPageType } from '../src/model/fragments'
import { usePageLink } from '../src/hooks/usePageLink'
import { useTranslate } from '../src/hooks/useTranslate'
import { ContactOfficeFragment } from '../src/model/fragments'
import { BarelyVisibleTitle } from './BarelyVisibleTitle'
import { Contained } from './Contained'
import { LightTabs } from './LightTabs'
import { MainContacts } from './MainContacts'
import { Spacer } from './Spacer'
import { WidthBound } from './WidthBound'

export interface ContactNavigatedProps {
	current: 'contactMap' | 'contactInfo' | 'contactSalesRepresentatives'
	offices: ContactOfficeFragment[]
}

export const ContactNavigated: React.FunctionComponent<ContactNavigatedProps> =
	({ current, children, offices }) => {
		const translate = useTranslate()
		const contactMapLink = usePageLink(SpecialPageType.contactMap)
		const contactInfoLink = usePageLink(SpecialPageType.contactInfo)
		const contactSalesRepresentativesLink = usePageLink(
			SpecialPageType.contactSalesRepresentatives,
		)

		return (
			<>
				<WidthBound>
					<LightTabs
						items={[
							...(contactMapLink
								? [
										{
											isActive: current === 'contactMap',
											label: translate('contacts-navigation-contactMap-label'),
											linkProps: contactMapLink,
										},
								  ]
								: []),
							...(contactInfoLink
								? [
										{
											isActive: current === 'contactInfo',
											label: translate('contacts-navigation-contactInfo-label'),
											linkProps: contactInfoLink,
										},
								  ]
								: []),
							...(contactSalesRepresentativesLink
								? [
										{
											isActive: current === 'contactSalesRepresentatives',
											label: translate(
												'contacts-navigation-contactSalesRepresentatives-label',
											),
											linkProps: contactSalesRepresentativesLink,
										},
								  ]
								: []),
						]}
					/>
				</WidthBound>
				<Contained>{children}</Contained>
				{offices.length > 0 && (
					<>
						<Spacer initial={80} />
						<BarelyVisibleTitle level={2}>
							{translate('businessInformation-label')}
						</BarelyVisibleTitle>
						<Spacer initial={30} />
						<MainContacts offices={offices} />
						<Spacer initial={120} />
					</>
				)}
			</>
		)
	}
